import * as tslib_1 from "tslib";
import { Type, } from '@angular/core';
import { MatDialog, } from '@angular/material/dialog';
import { UiDialogComponent } from '@components/ui-dialog/ui-dialog.component';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var NOOP = function () { };
var ɵ0 = NOOP;
var ModalService = /** @class */ (function () {
    function ModalService(dialog) {
        this.dialog = dialog;
    }
    // TODO: remove onOkay and onCancel to use only subscriptions
    ModalService.prototype.onConfirm = function (entryName, onOkay, onCancel, confirmationText, focusNoOption) {
        if (onOkay === void 0) { onOkay = NOOP; }
        if (onCancel === void 0) { onCancel = NOOP; }
        if (focusNoOption === void 0) { focusNoOption = false; }
        var dialogRef = this.dialog.open(UiDialogComponent);
        dialogRef.componentInstance.modalText = confirmationText || "Are you sure you want to delete " + entryName + "?";
        dialogRef.componentInstance.focusNoButton = focusNoOption;
        var afterClosed$ = dialogRef.afterClosed().pipe(map(Boolean));
        afterClosed$.subscribe(function (result) {
            if (result) {
                onOkay();
            }
            else {
                onCancel();
            }
        });
        return afterClosed$;
    };
    ModalService.prototype.onAlert = function (alertText) {
        var dialogRef = this.dialog.open(UiDialogComponent);
        dialogRef.componentInstance.isAlertDialog = true;
        dialogRef.componentInstance.modalText = alertText;
        dialogRef.backdropClick().subscribe(function () {
            dialogRef.close();
        });
        return dialogRef.afterClosed();
    };
    ModalService.prototype.closeAllDialogs = function () {
        if (this.dialog) {
            this.dialog.closeAll();
        }
    };
    ModalService.prototype.getModalConfig = function (data, additionalSettings) {
        return {
            data: data != null ? data : {},
            isNewEntry: data == null || !!(additionalSettings && additionalSettings.isDuplicate),
            isDuplicate: additionalSettings ? !!additionalSettings.isDuplicate : false,
            additionalData: additionalSettings ? additionalSettings.data : {},
            size: additionalSettings ? additionalSettings.size : '',
        };
    };
    ModalService.prototype.openModal = function (arg, data, additionalSettings) {
        var autoFocus = true;
        var position = {
            top: '30px',
        };
        var disableClose = true;
        var hasBackdrop = true;
        var closeOnNavigation = false;
        var panelClass = ['ui-modal-dialog'];
        if (additionalSettings) {
            if (additionalSettings.size) {
                panelClass.push("ui-modal-dialog--" + additionalSettings.size);
            }
            if (additionalSettings.overflow) {
                panelClass.push("ui-modal-dialog--overflow-visible");
            }
            if (additionalSettings.additionalClasses != null) {
                panelClass.push.apply(panelClass, additionalSettings.additionalClasses);
            }
            if (additionalSettings.autoFocus === false) {
                autoFocus = additionalSettings.autoFocus;
            }
            if (additionalSettings.position) {
                position = tslib_1.__assign({}, position, additionalSettings.position);
            }
            closeOnNavigation = !!(additionalSettings.closeOnNavigation);
            disableClose = !additionalSettings.allowBackdropClose;
            hasBackdrop = !additionalSettings.disableBackdrop;
        }
        var dialogRef = this.dialog
            .open(arg, {
            disableClose: disableClose,
            data: this.getModalConfig(data, additionalSettings),
            position: position,
            panelClass: panelClass,
            autoFocus: autoFocus,
            hasBackdrop: hasBackdrop,
            closeOnNavigation: closeOnNavigation,
        });
        dialogRef.customEvent = dialogRef.componentInstance.customEvent;
        dialogRef.afterClosedResult = function () { return dialogRef.afterClosed().pipe(filterNullOrUndefined()); };
        return dialogRef;
    };
    ModalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModalService_Factory() { return new ModalService(i0.ɵɵinject(i1.MatDialog)); }, token: ModalService, providedIn: "root" });
    return ModalService;
}());
export { ModalService };
export { ɵ0 };
